// 默认分组信息
export default {
  base_info: {
    key: 'base_info',
    name: '基本信息',
  },
  base_info2: {
    key: 'base_info2',
    name: '',
  },
  product_info: {
    key: 'product_info',
    name: '产品信息',
  },
  aggregation_info: {
    key: 'aggregation_info',
    name: '聚合信息',
  },
  task_info: {
    key: 'task_info',
    name: '任务信息',
  },

  agent_adv: {
    key: 'agent_adv',
    name: '账户信息',
  },

  good_effect: {
    key: 'good_effect',
    name: '转化效果',
  },

  impression_click_cost: {
    key: 'impression_click_cost',
    name: '展示、点击、消费',
  },

  new_account: {
    key: 'new_account',
    name: '新开',
  },

  plans_and_ideas: {
    key: 'plans_and_ideas',
    name: '计划和创意',
  },

  sale_info: {
    key: 'sale_info',
    name: '销售信息',
  },

  owners_info: {
    key: 'owners_info',
    name: '直客业绩',
  },

  account_statistics: {
    key: 'account_statistics',
    name: '账户统计',
  },

  media_and_adslot: {
    key: 'media_and_adslot',
    name: '媒体和栏位类型',
  },
};
